/* Preferred Wallet */
(function () {
  'use strict';

  class PreferredWallet extends HTMLElement {
    connectedCallback() {
      this.observer = new MutationObserver(() => this.filter());
      this.observer.observe(this, { childList: true, subtree: true });
      this.filter();
    }

    disconnectedCallback() {
      this.observer.disconnect();
    }

    preferredWallet() {
      if (window.ApplePaySession && window.ApplePaySession.canMakePayments()) return 'apple_pay';
      if (/Android/i.test(navigator.userAgent)) return 'google_pay';
      return 'paypal';
    }

    filter() {
      const wallets = this.querySelector('shopify-accelerated-checkout-cart:not([data-preferred])');
      if (!wallets) return;

      const configs = JSON.parse(wallets.getAttribute('wallet-configs') || '[]');
      const choice = [this.preferredWallet(), 'paypal']
        .map((name) => configs.find((config) => config.name === name))
        .find(Boolean);
      if (!choice) return;

      // Hiding buttons keeps their reserved space, so Shopify must render only the chosen wallet
      const preferred = document.createElement('shopify-accelerated-checkout-cart');
      Array.from(wallets.attributes).forEach((attribute) => preferred.setAttribute(attribute.name, attribute.value));
      preferred.setAttribute('wallet-configs', JSON.stringify([choice]));
      preferred.dataset.preferred = '';
      wallets.replaceWith(preferred);
    }
  }

  if (!window.customElements.get('preferred-wallet')) {
    window.customElements.define('preferred-wallet', PreferredWallet);
  }
})();
